import { Dictation } from '../_interfaces/dictation';

/** True once the client finished the S3 PUT and persisted copilot.uploaded_at. */
export function isUploaded(dictation: Pick<Dictation, 'copilot'>): boolean {
  return Boolean(dictation.copilot?.uploaded_at);
}
